// Zona horaria de negocio: Venezuela (America/Caracas, UTC-4).
// Todas las fechas se muestran en hora de Venezuela para coincidir con la regla "solo jugadas del día".
const CARACAS_TZ = "America/Caracas";

export const formatBs = (n) => {
  if (n == null || isNaN(n)) return "0,00";
  return Number(n).toLocaleString("es-VE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const formatUsd = (n) => {
  if (n == null || isNaN(n)) return "0.00";
  return Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// Peso Colombiano: enteros sin decimales, separador de miles con punto (es-CO). Ej. "5.000".
export const formatCop = (n) => {
  if (n == null || isNaN(n)) return "0";
  return Number(Math.round(n)).toLocaleString("es-CO", { maximumFractionDigits: 0 });
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("es-VE", {
      timeZone: CARACAS_TZ,
      day: "2-digit", month: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export const formatTime = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("es-VE", { timeZone: CARACAS_TZ, hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const formatDateOnly = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("es-VE", { timeZone: CARACAS_TZ, day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return iso;
  }
};
